jQuery(document).ready(function ($) {
    $('.carte').each(function () {

        var $carte = $(this);
        var mapId = $carte.attr('id');

        // SETTINGS
        var default_lat = 48.8;
        var default_lon = 10.0;
        var default_zoom = 3;

        // INITIALISATION DE LA MAP
        var map = L.map(mapId, { zoomControl: true }).setView([default_lat, default_lon], default_zoom);

        var osmLayer = L.tileLayer(
            'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}{r}.png',
            { maxZoom: 19 }
        ).addTo(map);

        map.scrollWheelZoom.disable();
        map.boxZoom.disable();
        map.keyboard.disable();

        map.dragging.enable();
        map.touchZoom.enable();
        map.doubleClickZoom.enable();

        // MARKERS & CLUSTER
        var markers = [];
        var markerClusters = L.markerClusterGroup({
            iconCreateFunction: function (cluster) {
                return L.divIcon({
                    html: `
                        <div class="cluster-icon">
                            <img src="/wp-content/themes/hh/src/img/mapmarker-empty.svg" />
                            <span>${cluster.getChildCount()}</span>
                        </div>
                    `,
                    className: 'custom-cluster',
                    iconSize: [40, 40]
                });
            }
        });

        var SVGicon = L.icon({
            iconUrl: '/wp-content/themes/hh/src/img/mapmarker.svg',
            iconSize: [32, 43],
            iconAnchor: [16, 43]
        });

        // CHARGEMENT DES MARKERS
        $carte.find('> .marker').each(function () {

            var $markerEl = $(this);

            var lat    = $markerEl.data('lat');
            var lng    = $markerEl.data('lng');
            var title  = $markerEl.data('title') || '';
            var texte  = $markerEl.data('texte') || '';
            var single = $markerEl.data('single');
            var link   = $markerEl.data('link') || '#';

            if (lat && lng) {

                var marker = L.marker([lat, lng], { icon: SVGicon });

                // Construction du bouton conditionnel
                var buttonHTML = '';
                if (single === 1 || single === "1") {
                    buttonHTML = `
                <a href="${link}" class="map-popup__btn">
                    En savoir +
                </a>
            `;
                }

                // Construction popup
                var popupHTML = `
            <div class="map-popup">
                ${title ? `<h3>${title}</h3>` : ''}
                ${texte ? `<p>${texte}</p>` : ''}
                ${buttonHTML}
            </div>
        `;

                marker.bindPopup(popupHTML, { autoPan: false });

                // Centrage sur le marker au clic
                marker.on('click', function (e) {
                    map.setView(e.latlng, map.getZoom());
                });

                markerClusters.addLayer(marker);
                markers.push(marker);
            }
        });

        // AJOUT DU CLUSTER À LA MAP
        map.addLayer(markerClusters);

        // FORCER LA TAILLE (utile si la map était invisible au chargement)
        setTimeout(function () {
            map.invalidateSize();
        }, 300);

        // VUE GLOBALE
        if (markers.length > 1) {
            map.setView([default_lat, default_lon], default_zoom);
        } else {
            map.setView([default_lat, default_lon], default_zoom);
        }

    });
});